import { z } from "zod";
import { type PeriodSelectOption } from "@/lib/period-select";
import { makeRoute } from "@/lib/router/utils";

export const Routes = {
  App: makeRoute("/app"),
  Projects: makeRoute("/app/projects", undefined, z.object({ fromUrl: z.string().optional() })),
  Project: makeRoute(
    "/app/projects/:id",
    z.object({ id: z.string().optional() }),
    z.object({
      fromUrl: z.string().optional(),
    }),
  ),
  ProjectOverview: makeRoute(
    "/app/projects/:id/overview",
    z.object({ id: z.string().optional() }),
    z.object({ fromUrl: z.string().optional() }),
  ),
  ProjectInfo: makeRoute(
    "/app/projects/:id/info",
    z.object({ id: z.string().optional() }),
    z.object({ fromUrl: z.string().optional() }),
  ),
  ProjectShifts: makeRoute(
    "/app/projects/:id/shifts",
    z.object({ id: z.string().optional() }),
    z.object({ fromUrl: z.string().optional() }),
  ),
  UpcomingShifts: makeRoute("/app/shifts/upcoming"),

  // Shifts
  CompletedShifts: makeRoute(
    "/app/shifts/completed",
    undefined,
    z.object({
      period: z
        .enum([
          "this-month",
          "this-year",
          "last-year",
          "all-years",
        ] as const satisfies ReadonlyArray<PeriodSelectOption>)
        .default("this-month"),
    }),
  ),
  Shift: makeRoute(
    "/shifts/:id",
    z.object({ id: z.string().optional() }),
    z.object({ modal: z.enum(["hours", "travel-expenses"]).optional() }),
  ),

  // Settings
  Settings: makeRoute("/app/settings"),
  PersonalInformation: makeRoute("/settings/personal-information"),
  CustomFields: makeRoute("/settings/custom-fields"),
  Notifications: makeRoute("/settings/notifications"),
  NotificationsDevices: makeRoute("/settings/notifications/devices"),
  Contact: makeRoute("/settings/contact"),
  Privacy: makeRoute("/settings/privacy"),

  Auth: makeRoute("/auth"),

  AuthSignIn: makeRoute("/auth/sign-in"),
  AuthSignInPassword: makeRoute(
    "/auth/sign-in/password",
    undefined,
    z.object({
      callbackUrl: z.string().optional(),
    }),
  ),

  AuthSignUpProfile: makeRoute("/auth/sign-up/profile"),

  AuthForgotPassword: makeRoute("/auth/forgot-password"),
  AuthForgotPasswordVerify: makeRoute("/auth/forgot-password/verify"),
  AuthForgotPasswordReset: makeRoute("/auth/reset-password"),
  AuthAcceptInvite: makeRoute(
    "/auth/accept-invitation/:token",
    z.object({
      token: z.string().optional(),
    }),
  ),
  AuthRegister: makeRoute("/auth/register"),
  AuthRegisterSuccess: makeRoute("/auth/register/success"),

  // Conversations
  Conversations: makeRoute("/app/conversations"),
  Conversation: makeRoute("/app/conversations/:id", z.object({ id: z.string().optional() })),
  ConversationInfo: makeRoute(
    "/app/conversations/:id/info",
    z.object({ id: z.string().optional() }),
  ),
};
